import { isEqual } from 'lodash';
import { TOAST } from '../actionTypes';
import { deepClone } from '../../utils/global_functions';



  
  export const  toastConfig =  (payload) => {
      return { type:TOAST.HANDLE_TOAST, payload };
  };


export const updateToastChildrenData = (objToRemove) => async (dispatch,getState) => {
   const childrenDataArray = deepClone(getState()?.toast?.childrenData)

 
   let removeObjIndex

   for(let i=0; i< childrenDataArray.length; i++ ){
    removeObjIndex = i
      if(isEqual(childrenDataArray[i],objToRemove)){ 
        break;
      }
   }

  
    childrenDataArray.splice(removeObjIndex,1)
    dispatch(handleToastChildrenData([...childrenDataArray]))
   
 
}


  export const handleToastChildrenData = (payload)=>{
      return {type:TOAST.HANDLE_CHILDREN_DATA, payload}
  }